import { FreeSpinsRetrievalTarget } from "../types/FreeSpinsRetrieval";

/** Integrator and skin ids can coincide; the type tells them apart. */
export const isSameTarget = (
  target: FreeSpinsRetrievalTarget,
  other: FreeSpinsRetrievalTarget | null,
): boolean => target.type === other?.type && target.id === other.id;
